import { cn } from "@/shared/lib/cn";
import { GenerativeAvatar } from "@/shared/ui";

const SIZES = {
  sm: "size-9 rounded-md",
  md: "size-12 rounded-lg",
  lg: "size-20 rounded-2xl",
} as const;

export interface AssistantIconProps {
  name: string;
  iconUrl?: string | null;
  size?: keyof typeof SIZES;
  className?: string;
}

/**
 * An assistant's avatar: the uploaded/generated icon when present, otherwise a
 * deterministic generative avatar (a colored tile + a purpose-matched glyph) —
 * never text, never an empty box.
 */
export function AssistantIcon({ name, iconUrl, size = "md", className }: AssistantIconProps) {
  if (iconUrl) {
    return (
      <img
        src={iconUrl}
        alt=""
        className={cn("shrink-0 object-cover", SIZES[size], className)}
      />
    );
  }
  return <GenerativeAvatar seed={name} className={cn(SIZES[size], className)} />;
}
